import React from "react";
import { useLocalizedStrings } from "../Localization";
import { useAPIPost } from "../API";
import { useParams } from "react-router-dom";

import { QuestionProps } from './Props';
import { Attachment } from "./Attachment";
import { LinkSender } from "../Components/LinkSender";

export function SelfieQuestion(props: QuestionProps) {
    const L = useLocalizedStrings();
    
    const getSelfieLink = useAPIPost("/get_selfie_shortlink");
    const { uid } = useParams() as Record<string, string>;
    const host = window.location.protocol + "//" + window.location.host;

    async function getLink(lang: string) {
        const resp = await getSelfieLink({ applicant: uid, target_field: props['Target Field']!, host, lang });
        return resp.short_link;
    }
    return <div>
        <h3>{L.selfie.title}</h3>
        <LinkSender message={{'en': props['English Content'], es: props['Spanish Content']!}} 
            toastMessage={L.applicant.link_sent} 
            defaultValue={props.info['phone_number']}
            linkCreator={getLink}></LinkSender>
        <br /><br />
        {props.info[props["Target Field"]!] ?
            props.info[props["Target Field"]!].split(',').map((url: string) => {
                return <Attachment info={props.info} 
                    targetField={props["Target Field"]!}
                    key={url} url={url} />;
            }) : ''}
    </div>
}